import { Chains, VaultList, } from "../../constants/constants";
import { assetFilterList, getChainByAsset } from "../../utils/asset";
export var ProductList = [
    "yield",
    "volatility",
    "principalProtection",
    "capitalAccumulation",
];
export var VaultStrategyList = ["All Strategies", "Covered Call", "Put Selling"];
export var VaultSortByList = [
    "Sort By",
    "Newest First",
    "Oldest First",
    "Yield: High To Low",
    "Yield: Low To High",
];
export var VaultSortByFilterOptions = VaultSortByList.map(function (item) {
    return item === VaultSortByList[0]
        ? {
            display: "Default",
            value: item,
        }
        : item;
});
export var VaultReleaseOrder = VaultList;
export var getFilterAssets = function (chain) {
    if (chain === Chains.NotSelected) {
        return assetFilterList;
    }
    return assetFilterList.filter(function (asset) { return getChainByAsset(asset) === chain; });
};
//# sourceMappingURL=types.js.map